import React from "react";

export default function Terms() {
  return (
    <div className="min-h-screen text-white bg-[#0b0f19] py-16 px-6 max-w-4xl mx-auto leading-relaxed">

      <h1 className="text-4xl font-bold mb-6 text-cyan-400">Terms of Service</h1>

      <p className="mb-4">
        These Terms govern your access and use of NuclearEnergyAgent.com ("the Service").
        By using the Service, you agree to these terms.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">1. Use of the Service</h2>
      <p className="mb-4">
        You agree not to misuse, reproduce, or redistribute any part of the system or generated content.
        The Service is for informational and research-assistance purposes only.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">2. Uploaded Content</h2>
      <p className="mb-4">
        You confirm that you have the rights to upload any document you submit.
        We are not responsible for copyrighted or sensitive material uploaded by users.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">3. Output Limitations</h2>
      <p className="mb-4">
        The summaries and variable extractions are AI-generated and may contain inaccuracies.
        Do not use them as final scientific, engineering, medical, or legal advice.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">4. Credits & Billing</h2>
      <p className="mb-4">
        Credit packs and subscription plans are non-refundable.
        Misuse, abuse, or automated scraping may result in account termination.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">5. Liability</h2>
      <p className="mb-4">
        We are not liable for decisions made based on generated summaries or extracted variables.
        Use at your own discretion.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">6. Contact</h2>
      <p className="mb-4">
        For any questions, reach out to:
        <span className="text-cyan-400 font-semibold ml-1">support@nuclearenergyagent.com</span>
      </p>

      <p className="mt-10 opacity-70">Last updated: November 2025</p>

    </div>
  );
}
